/**
 * Defined in:
 *   {@link file://./../../dxos/iframe.proto}
 */
export var ShellDisplay;
(function (ShellDisplay) {
    ShellDisplay[ShellDisplay["NONE"] = 0] = "NONE";
    ShellDisplay[ShellDisplay["FULLSCREEN"] = 1] = "FULLSCREEN";
})(ShellDisplay || (ShellDisplay = {}));
/**
 * Defined in:
 *   {@link file://./../../dxos/iframe.proto}
 */
export var ShellLayout;
(function (ShellLayout) {
    ShellLayout[ShellLayout["DEFAULT"] = 0] = "DEFAULT";
    ShellLayout[ShellLayout["INITIALIZE_IDENTITY"] = 1] = "INITIALIZE_IDENTITY";
    ShellLayout[ShellLayout["INITIALIZE_IDENTITY_FROM_INVITATION"] = 2] = "INITIALIZE_IDENTITY_FROM_INVITATION";
    ShellLayout[ShellLayout["INITIALIZE_IDENTITY_FROM_RECOVERY"] = 9] = "INITIALIZE_IDENTITY_FROM_RECOVERY";
    ShellLayout[ShellLayout["IDENTITY"] = 3] = "IDENTITY";
    ShellLayout[ShellLayout["SHARE_IDENTITY"] = 4] = "SHARE_IDENTITY";
    ShellLayout[ShellLayout["EDIT_PROFILE"] = 5] = "EDIT_PROFILE";
    ShellLayout[ShellLayout["SPACE"] = 6] = "SPACE";
    ShellLayout[ShellLayout["JOIN_SPACE"] = 7] = "JOIN_SPACE";
    ShellLayout[ShellLayout["STATUS"] = 8] = "STATUS";
})(ShellLayout || (ShellLayout = {}));
//# sourceMappingURL=iframe.js.map